import { observer } from '@poa/state';
import React from 'react';
import {
  calculateSumByHeaderId,
  findAggregationTypeByHeaderId,
  getValue
} from './data-table-helpers';

export const DataTableFooter = observer(
  ({ data, columnSettings, isDecimalThunk, headersOrder, headersKeys }) => {
    const tfoot = [];
    const tfootData = data.get().tfoot;
    const tbodyData = data.get().tbody;
    const theadData = data.get().thead;

    if (!tfootData) {
      return null;
    }

    headersOrder
      .get()
      .filter(c => !c.name.startsWith('@@'))
      .forEach(columnSetting => {
        const sectionId = columnSetting.sectionId;
        const headerId = columnSetting.name;

        if (!tfootData[sectionId][headerId]) {
          tfoot.push(
            <td key={`foot-${sectionId}-${headerId}`} className={`table__${headerId}`}>
              {' '}
            </td>
          );
          return;
        }

        if (columnSetting && columnSetting.isSelected === false) {
          return;
        }

        const aggType = findAggregationTypeByHeaderId(theadData, headerId);
        let tfootValue;

        if (aggType === 'none') {
          tfootValue = tfootData[sectionId][headerId].value;
        }

        if (aggType === 'sum') {
          tfootValue = calculateSumByHeaderId(tbodyData, headerId);
        }

        tfoot.push(
          <td
            key={`foot-${sectionId}-${headerId}`}
            className={`table__${headerId}`}
            style={{ width: columnSetting.width }}
          >
            {getValue(tfootValue, isDecimalThunk())}
          </td>
        );
      });

    return (
      <tfoot>
        <tr>
          {/* <td /> */}
          {tfoot}
        </tr>
      </tfoot>
    );
  }
);
